import { render } from "./ListActive.vue?vue&type=template&id=72a8e8e2"
import script from "./ListActive.vue?vue&type=script&lang=js"
export * from "./ListActive.vue?vue&type=script&lang=js"

import "./ListActive.vue?vue&type=style&index=0&id=72a8e8e2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__